import * as moment from "moment";

export const validateStreetAddressErrors = (name) => {
  // try {
  const regex = RegExp(/^.*$/);
  if (name.length > 2) {
    if (regex.test(name)) {
      return false;
    } else {
      return "mailing_address.street_address_error";
    }
  } else {
    // setStreetAddressValid(false)
    // setStreetAddressError('mailing_address.street_address_error')
    return "mailing_address.street_address_error";
  }
  // } catch (e) {
  //     console.log(e)
  //     setIsError(true)
  // }
};

export const validateHouseNumberErrors = (houseNumber) => {
  const regex = RegExp(/^[0-9]*$/);
  if (houseNumber.length > 1) {
    if (regex.test(houseNumber)) {
      return false;
    } else {
      return "mailing_address.house_number_error";
    }
  } else {
    // setStreetAddressValid(false)
    // setStreetAddressError('mailing_address.street_address_error')
    return "mailing_address.house_number_error";
  }
};

export const validateStreetNameErrors = (
  streetName,
  isMailingAddress = false
) => {
  // const regex = RegExp(
  //   /^[a-zA-Z0-9-`‘’'.,àâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ ]*$/
  // );
  const pattern = RegExp(
    /^(?=.*[a-zA-Z])(?=.*[0-9]).*$/
  );
   // Step 1: Limit input length
   const maxInputLength = 50;
   if (streetName.length < 1) {
    return  "mailing_address.street_address_error";
   }else{
    return false
   }
  
   // Step 2: Sanitize input
  //  const sanitizedInput = streetName.trim();
  
  // if (streetName.length > 2 ) {
  //   if (pattern.test(sanitizedInput)) {
  //     return false;
  //   } else {
  //     return "mailing_address.street_address_error"
  //   }
  // } else {
  //   // setStreetAddressValid(false)
  //   // setStreetAddressError('mailing_address.street_address_error')
  //   return isMailingAddress
  //     ? "mailing_address.mailing_address_error"
  //     : "mailing_address.street_name_error";
  // }
};

export const validateBruStreetNameErrors = (
  streetName,
  isMailingAddress = false
) => {
  // const regex = RegExp(
  //   /^[a-zA-Z0-9-`‘’'.,àâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ ]*$/
  // );
  const pattern = RegExp(
    /^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9-`‘’'.,àâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ ]+$/
  );
  // Step 1: Limit input length
  const maxInputLength = 31;
  if (streetName.length > maxInputLength) {
    return isMailingAddress
        ? "mailing_address.mailing_address_error"
        : "mailing_address.street_name_error";
  }
 
  // Step 2: Sanitize input
  const sanitizedInput = streetName.trim();
  if (streetName.length > 0 && streetName.length <= 30) {
    if (pattern.test(sanitizedInput)) {
      return false;
    } else {
      return isMailingAddress
        ? "mailing_address.mailing_address_error"
        : "mailing_address.street_name_error";
    }
  } else {
    return false;
  }
};

export const validateStreetTypeErrors = (houseNumber) => {
  const regex = RegExp(/^[a-zA-Z-`‘’'àâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ ]*$/);
  if (houseNumber.length >= 2) {
    if (regex.test(houseNumber)) {
      return false;
    } else {
      return "mailing_address.street_type_error";
    }
  } else {
    // setStreetAddressValid(false)
    // setStreetAddressError('mailing_address.street_address_error')
    return "mailing_address.street_type_error";
  }
};

export const validateApartmentErrors = (name, required = false) => {
  const regex = RegExp(/^[a-zA-Z0-9-`‘’'àâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ ]*$/);
      // Step 1: Limit input length
      const maxInputLength = 5;
      if (name?.length > maxInputLength) {
        return "errors.apartment_error_invalid";
      }
     
  //     // Step 2: Sanitize input
  //     const sanitizedInput = name.trim();
     
  
  // if (name?.length > 0 && name?.length <= 15) {
  //   if (regex.test(sanitizedInput)) {
  //     return false;
  //   } else {
  //     return "errors.apartment_error_invalid";
  //   }
  // } else {
  //   return required || name?.length >= 15 ? "errors.apartment_required" : false;
  // }
};

export const validateCityErrors = (cityName, required = true) => {
  // try {
  const regex = RegExp(
    /^[a-zA-Z0-9-`‘’',.àâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ ]*$/
  );
// Step 1: Limit input length
const maxInputLength = 60;
if (cityName.length < 1) {
  return "mailing_address.city_error";
}

// Step 2: Sanitize input
// const sanitizedInput = cityName.trim();

//   if (cityName.length > 2 && cityName?.length <= 35) {
//     if (regex.test(sanitizedInput)) {
//       return false;
//     } else {
//       return "mailing_address.city_error";
//       // setCityValid(false)
//       // setCityError('mailing_address.city_error_invalid')
//     }
//   } else {
//     return "mailing_address.city_error";
//     // setCityValid(false)
//     // setCityError('mailing_address.city_error')
//   }
  // } catch (e) {
  //     console.log(e)
  //     setIsError(true)
  // }
};

// export const validateCityErrors = (cityName) => {
//   try {
//     const regex = RegExp(/^[a-zA-Z0-9-`‘’'àâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ ]*$/);
//     if (cityName.length > 0) {
//       if (regex.test(cityName)) {
//         return false;
//       } else {
//         return "mailing_address.city_error";
//       }
//     } else {
//       return "mailing_address.city_error";
//     }
//   } catch (e) {
//     console.log(e);
//   }
// };

export const validateBruCityErrors = (cityName) => {
  // try {
  const regex = RegExp(/^[a-zA-Z-`‘’',.àâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ ]*$/);
  if (cityName.length > 0 && cityName?.length <= 35) {
    if (regex.test(cityName)) {
      return false;
    } else {
      return "mailing_address.city_error";
    }
  } else {
    return false;
  }
};

export const validatePaymentAmountErrors = (amount) => {
  if (!amount) {
    return "errors.payment_amount_invalid";
  }

  const amountFlt = parseInt(amount);
  if (isNaN(amountFlt)) {
    return "errors.payment_amount_invalid";
  }

  // multiply by 100 to get value in cents
  if (amountFlt > 10000 * 100) {
    return "errors.payment_amount_must_be_less";
  }

  if (amountFlt < 100) {
    return "errors.payment_amount_must_be_more";
  }

  return false;
};

export const validateFileNumberErrors = (fileNumber) => {
  if (!fileNumber || fileNumber.length !== 6) {
    return "errors.file_number_empty";
  }
  const regex = RegExp(/^[0-9]{6}$/);
  if (!regex.test(fileNumber)) {
    return "errors.file_number_invalid";
  }

  return false;
};

export const validateSINNumberErrors = (sinNumber, primary, othersSin) => {
  let sinTrim = sinNumber?.replace(/ /g, "");
  if (!sinTrim || sinTrim?.length !== 9) {
    return "errors.sin_number_empty";
  }
  const regex = RegExp(/^[0-9]{9}$/);
  if (!regex?.test(sinTrim)) {
    return "errors.sin_number_invalid";
  }
if(sinNumber === primary){
  return "errors.sin_number_duplicate";
}
if (othersSin?.includes(sinNumber)) {
    return "errors.other_sin_number_duplicate";
    
  }

  // call valid sin number check
  const algorithmNum = sinTrim?.slice(0, -1);
  const checkDigit = parseInt(sinTrim?.substr(-1));

  //From the rightmost digit (excluding the check digit) and moving left
  const arr = [...algorithmNum]?.reverse();
  const products = arr?.map((character, index) => {
    //double the value of every second digit
    const num = parseInt(character);
    if (index % 2 === 0) {
      const product = num * 2;
      // If the result of this doubling operation is greater than 9 (e.g., 8 × 2 = 16),
      // then add the digits of the result (e.g., 16: 1 + 6 = 7, 18: 1 + 8 = 9) or,
      // equivalently, subtract 9 from the result
      return product > 9 ? product - 9 : product;
    }

    return num;
  });
  const sum = products?.reduce((prevVal, currVal) => {
    return prevVal + currVal;
  }, 0);

  //Take the sum of all the digits (including the check digit).
  const totalSum = sum + checkDigit;

  //If the total modulo 10 is equal to 0 (if the total ends in zero)
  // then the number is valid according to the Luhn formula; otherwise it is not valid.
  const isValid = totalSum % 10 === 0;
  return isValid ? false : "errors.sin_number_invalid";
};

export const validateBruSINNumberErrors = (sinNumber) => {
  let sinTrim = sinNumber?.replace(/ /g, "");

  if (sinTrim.length === 0) {
    return false;
  }

  if (!sinTrim || sinTrim.length !== 9) {
    return "errors.sin_number_empty";
  }
  const regex = RegExp(/^[0-9]{9}$/);
  if (!regex.test(sinTrim)) {
    return "errors.sin_number_invalid";
  }

  // call valid sin number check
  const algorithmNum = sinTrim.slice(0, -1);
  const checkDigit = parseInt(sinTrim.substr(-1));

  //From the rightmost digit (excluding the check digit) and moving left
  const arr = [...algorithmNum].reverse();
  const products = arr.map((character, index) => {
    //double the value of every second digit
    const num = parseInt(character);
    if (index % 2 === 0) {
      const product = num * 2;
      // If the result of this doubling operation is greater than 9 (e.g., 8 × 2 = 16),
      // then add the digits of the result (e.g., 16: 1 + 6 = 7, 18: 1 + 8 = 9) or,
      // equivalently, subtract 9 from the result
      return product > 9 ? product - 9 : product;
    }

    return num;
  });
  const sum = products.reduce((prevVal, currVal) => {
    return prevVal + currVal;
  }, 0);

  //Take the sum of all the digits (including the check digit).
  const totalSum = sum + checkDigit;

  //If the total modulo 10 is equal to 0 (if the total ends in zero)
  // then the number is valid according to the Luhn formula; otherwise it is not valid.
  const isValid = totalSum % 10 === 0;
  return isValid ? false : "errors.sin_number_invalid";
};

export const validateFileNumberVINErrors = (fileNumber) => {
  if (!fileNumber || fileNumber.length < 2 || fileNumber.length > 17) {
    return "errors.file_number_vin_empty";
  }
  const regex = RegExp(/^[a-zA-Z0-9]*$/);
    // Step 1: Limit input length
    const maxInputLength = 17;
    if (fileNumber.length > maxInputLength) {
      return "errors.file_number_vin_empty";
    }
   
    // Step 2: Sanitize input
    const sanitizedInput = fileNumber.trim();
   
  if (!regex.test(sanitizedInput)) {
    return "errors.file_number_vin_invalid";
  }

  return false;
};

export const validatePostalCodeErrors = (number, country) => {
  // if country is USA then use zip code validation
  if (country === "USA") {
    const regex = RegExp(/(^\d{5}$)|(^\d{5}-\d{4}$)/);
  // Step 1: Limit input length
  const maxInputLength = 100;
  if (number.length > maxInputLength) {
    return "mailing_address.zip_code_error";
  }
 
  // Step 2: Sanitize input
  const sanitizedInput = number.trim();
    if (!regex.test(sanitizedInput)) {
      return "mailing_address.zip_code_error";
    }
  } else if (country === "Canada") {
    const regex = RegExp(/^[B]\d[A-Za-z][ -]?\d[A-Za-z]\d$/i);
          // Step 1: Limit input length
  const maxInputLength = 100;
  if (number.length > maxInputLength) {
    return "mailing_address.ns_postal_code_error";
  }
 
  // Step 2: Sanitize input
  const sanitizedInput = number.trim();
    if (!regex.test(sanitizedInput)) {
      return "mailing_address.ns_postal_code_error";
    }
  } else {
    const regex = RegExp(
      /^[a-zA-Z0-9-`‘’'àâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ ]*$/
    );
       // Step 1: Limit input length
  const maxInputLength = 10;
  if (number.length > maxInputLength) {
    return "mailing_address.ns_postal_code_or_zip_error";
  }
 
  // Step 2: Sanitize input
  const sanitizedInput = number.trim();
 
    if (!regex.test(sanitizedInput) ||  number.length === 0) {
      return "mailing_address.ns_postal_code_or_zip_error";
    }
  }
  return false;
};

export const validateBruPostalCodeErrors = (number, country) => {
  // if country is USA then use zip code validation
  if (country === "USA") {
    const regex = RegExp(/(^\d{5}$)|(^\d{5}-\d{4}$)/);
     // Step 1: Limit input length
  const maxInputLength = 300;
  if (number.length > maxInputLength) {
    return "mailing_address.zip_code_error";
  }
 
  // Step 2: Sanitize input
  const sanitizedInput = number.trim();
 
    if (!regex.test(sanitizedInput)) {
      return "mailing_address.zip_code_error";
    }
  } else if (country === "Canada" && number.length > 0) {
    const regex = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/i;
    // Step 1: Limit input length
  const maxInputLength = 300;
  if (number.length > maxInputLength) {
    return "mailing_address.ns_postal_code_error";
  }
 
  // Step 2: Sanitize input
  const sanitizedInput = number.trim();
 
  // Step 3: Test against regex
  if (!regex.test(sanitizedInput)) {
    // throw new Error("Invalid input format");
    return "mailing_address.ns_postal_code_error";
  }
 
  // Valid input
  console.log("Input is valid");

  } else {
    return false;
  }
};

export const validateFullNameErrors = (name) => {
  const regex = RegExp(/^[a-zA-Z-`‘’'àâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ ]*$/);
  if (name.length === 0) {
    return "contact_information.full_name_error";
  }
  if (name.length <= 1) {
    return "contact_information.full_name_error_less_characters";
  }
  if (!regex.test(name)) {
    return "contact_information.full_name_error_invalid";
  }

  return false;
};

export const validateBruFullNameErrors = (name) => {
  const regex = RegExp(/^[a-zA-Z-`‘’'àâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ ]*$/);
  if (name.length === 0) {
    return false;
  }
  if (name.length <= 1) {
    return "contact_information.full_name_error_less_characters";
  }
  if (!regex.test(name)) {
    return "contact_information.full_name_error_invalid";
  }

  return false;
};

export const validateLastNameErrors = (name) => {
  const regex = RegExp(/^[a-zA-Z-`‘’'àâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ ]*$/);
  if (name.length === 0) {
    return "contact_information.last_name_error";
  }
  if (name.length <= 1) {
    return "contact_information.last_name_error_less_characters";
  }
  if (!regex.test(name)) {
    return "contact_information.last_name_error_invalid";
  }

  return false;
};

export const validateBruLastNameErrors = (name) => {
  const regex = RegExp(/^[a-zA-Z-`‘’'àâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ ]*$/);
  if (name.length === 0) {
    return false;
  }
  if (name.length <= 1) {
    return "contact_information.last_name_error_less_characters";
  }
  if (!regex.test(name)) {
    return "contact_information.last_name_error_invalid";
  }

  return false;
};

export const validateNameErrors = (name) => {
  if (name.length <= 1) {
    return "errors.business_name_error";
  }

  return false;
};

export const validateBusinessNumberErrors = (name) => {
  if (name.length <= 1) {
    return "errors.business_number_error";
  }

  return false;
};

export const validateCompletedTaxYearEndErrors = (value) => {
  if (value.length !== 4 || isNaN(parseInt(value))) {
    return "errors.business_completed_tax_year_error";
  }

  return false;
};

export const validateRegistryIdErrors = (value) => {
  if (value.length <= 1) {
    return "errors.business_registry_id_error";
  }

  return false;
};

export const validateGrossRevenueErrors = (value) => {
  if (value.length <= 1 || isNaN(parseFloat(value))) {
    return "errors.business_gross_revenue_error";
  }

  return false;
};

export const validateAltPhoneNumberErrors = (number, required = false) => {
  if (number?.length > 0) {
    if (number.length !== 12) {
      return "contact_information.phone_number_error_invalid";
    } else {
      return false;
    }
  } else {
    return required ? "contact_information.phone_number_error_invalid" : null;
  }
};

export const validatePhoneNumberErrors = (number) => {
  if (number.length === 0) {
    return "contact_information.phone_number_error_invalid"; //return "contact_information.phone_number_error";
  }
  if (number.length !== 12) {
    return "contact_information.phone_number_error_invalid";
  }
  return false;
  // if (number?.length > 0) {
  //   if (number.length !== 12) {
  //     return "contact_information.phone_number_error_invalid";
  //   } else {
  //     return false;
  //   }
  // }
  // // return false;
  // else {
  //   return "contact_information.phone_number_error";
  // }
};

export const validateEmailErrors = (email) => {
  // eslint-disable-next-line
  const regex = RegExp(
    // eslint-disable-next-line no-useless-escape
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  );
  if (email.length === 0) {
    return "contact_information.email_address_error";
  }
  if (!regex.test(email)) {
    return "contact_information.email_address_error_invalid";
  }

  return false;
};

export const validateTitleErrors = (title) => {
  if (title.length === 0) {
    return "mailing_address.email_address_error";
  }

  return false;
};

export const validateCountryErrors = (country) => {
  if (country.length === 0) {
    return "mailing_address.country_required_error";
  }

  return false;
};

export const validateSpecifyErrors = (specify) => {
  if (specify.length === 0) {
    return "mailing_address.specify_required_error";
  }

  return false;
};

export const validateProvinceOrStateErrors = (country, provinceOrState) => {
  if (provinceOrState.length === 0) {
    return "mailing_address.province_or_state_required_error";
  }

  return false;
};

export const validateProvinceErrors = (province) => {
  if (province.length === 0) {
    return "errors.province_required";
  }

  return false;
};

export const validateQuantityErrors = (quantity) => {
  if (!quantity) {
    return "mailing_address.email_address_error";
  }

  return false;
};

export const validateDateOfBirthErrors = (inputDate) => {
  if (moment(inputDate).isValid()) {
    if (!moment(inputDate).isAfter(moment().format("YYYY-MM-DD"), "day")) {
      return false;
    } else {
      return "contact_information.date_of_birth_error";
    }
  } else {
    return "contact_information.date_of_birth_error";
  }
};
